module.exports = __webpack_public_path__ + "static/img/4.13023bf3.jpg";